import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type SocialProofItem = {
  name: string;
  location: string;
  action: string;
  time: string;
  avatarUrl: string;
};
const SOCIAL_PROOF_DATA: SocialProofItem[] = [{
  name: 'Lidia',
  location: 'Texas',
  action: 'just downloaded the guide',
  time: '1 min ago',
  avatarUrl: 'https://i.pravatar.cc/80?img=1'
}, {
  name: 'Emily',
  location: 'California',
  action: 'claimed her emotional reset',
  time: 'just now',
  avatarUrl: 'https://i.pravatar.cc/80?img=16'
}, {
  name: 'Zoe',
  location: 'New York',
  action: 'unlocked her bonus phrases',
  time: '2 mins ago',
  avatarUrl: 'https://i.pravatar.cc/80?img=20'
}, {
  name: 'Grace',
  location: 'Florida',
  action: 'downloaded the clarity toolkit',
  time: '3 mins ago',
  avatarUrl: 'https://i.pravatar.cc/80?img=23'
}, {
  name: 'Mia',
  location: 'Oregon',
  action: 'started her shift today',
  time: 'just now',
  avatarUrl: 'https://i.pravatar.cc/80?img=29'
}, {
  name: 'Olivia',
  location: 'Illinois',
  action: 'just joined',
  time: 'now',
  avatarUrl: 'https://i.pravatar.cc/80?img=10'
}, {
  name: 'Sarah',
  location: 'London',
  action: 'found peace after the breakup',
  time: '5 mins ago',
  avatarUrl: 'https://i.pravatar.cc/80?img=5'
}, {
  name: 'Elena',
  location: 'Toronto',
  action: 'reclaimed her confidence',
  time: 'just now',
  avatarUrl: 'https://i.pravatar.cc/80?img=9'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    const cycleInterval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % SOCIAL_PROOF_DATA.length);
          setIsVisible(true);
        }
      }, 1000);
    }, 15000);
    const hideTimeout = setTimeout(() => {}, 5000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(cycleInterval);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  useEffect(() => {
    if (isVisible && !isDismissed) {
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);
      return () => clearTimeout(hideTimer);
    }
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const currentItem = SOCIAL_PROOF_DATA[currentIndex];
  return <div className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-50 max-w-[320px] w-full transition-all duration-700 ease-in-out transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-205">
      <div className="relative flex items-center gap-4 p-5 rounded-2xl shadow-xl border-2 backdrop-blur-sm" style={{
      backgroundColor: 'rgba(255, 255, 255, 0.98)',
      borderColor: '#f4a6b8',
      boxShadow: '0 12px 40px rgba(244, 166, 184, 0.25)'
    }} data-id="element-206">
        {/* Close Button */}
        <button onClick={() => setIsDismissed(true)} className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-sm hover:bg-gray-50 transition-colors border-2 border-[#f4a6b8]" aria-label="Close notification" data-id="element-207">
          <X size={12} className="text-[#f4a6b8]" data-id="element-208" />
        </button>

        {/* Avatar */}
        <img src={currentItem.avatarUrl} alt={currentItem.name} className="flex-shrink-0 w-12 h-12 rounded-full object-cover shadow-md border-2 border-[#f4a6b8]" data-id="element-209" />

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-210">
          <p className="text-base font-serif font-semibold text-[#4B2F2F] leading-tight truncate" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-211">
            {currentItem.name}{' '}
            <span className="font-normal text-[#8D746B] text-sm" data-id="element-212">
              from {currentItem.location}
            </span>
          </p>
          <p className="text-sm text-[#6E5B50] mt-1 leading-snug" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-213">
            {currentItem.action}
          </p>
          <p className="text-xs text-[#f4a6b8] mt-1.5 font-medium uppercase tracking-wide" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-214">
            {currentItem.time}
          </p>
        </div>
      </div>
    </div>;
}